import React from "react";
import Svg, { Path, G, Defs, ClipPath } from "react-native-svg";

function Address(props) {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M19.9995 12.0454L14.5782 1.84375L8.70752 22.5L19.9995 12.0454Z"
        fill="#008C46"
      />
      <Path
        d="M16.292 11.2017L10.8707 1L5 21.6562L16.292 11.2017Z"
        fill="#FF782D"
      />
    </Svg>
  );
}

export default Address;
